// @flow

import React, { type Node, useState } from 'react';

import { Separator } from '../../../../../atoms';
import { IfFeature } from '@tectonics/prs/feature';
import { useAllFeatures } from '@tectonics/prs/payment-spec';
import { useSendVoucherGenerateEvent } from '@tectonics/analytics';

import { MailWarning } from './mail-warning';
import { BoletoNumber } from './boleto-number';
import { BoletoBarcode } from './boleto-barcode';
import { BoletoTipsBox } from './boleto-tips-box';
import { DisplayDueDate } from './display-due-date';
import { SaveToPdfButton } from './save-to-pdf-button';
import { DisplayTotalAmount } from './display-total-amount';
import { CopyToClipboardButton } from './copy-to-clipboard-button';
import { StatusMessage } from './status-message';
import { useEventBusListener } from '@tectonics/public-event-bus';

import { IofDisplay } from '../../../../commons/iof/components';

export function BoletoPageContent(): Node {
  const features = useAllFeatures();
  const [isReady, setReady] = useState<bool>(false);

  useEventBusListener('bromelia:step:thank_you', () => {
    setReady(true);
  });

  useSendVoucherGenerateEvent(isReady);

  return (
    <div data-test-id="page-pending-payment" className="content-box content-box__row">

      <IfFeature allFeatures={features} wanted="display_receipt_brazilian_tax_iof">
        <IofDisplay />
      </IfFeature>

      <StatusMessage />

      <p style={BoletoTitleStyle}>
        Seu boleto foi gerado! :)
      </p>

      <IfFeature allFeatures={features} wanted="display_boleto_email_warning">
        <MailWarning />
      </IfFeature>

      <div style={PaymentInfoWrapperStyle}>

        <IfFeature allFeatures={features} wanted="display_boleto_total_value">
          <DisplayTotalAmount />
        </IfFeature>

        <IfFeature allFeatures={features} wanted="display_boleto_due_date">
          <DisplayDueDate />
        </IfFeature>

      </div>

      <Separator />

      <IfFeature allFeatures={features} wanted="display_boleto_barcode">
        <BoletoBarcode />
      </IfFeature>

      <IfFeature allFeatures={features} wanted="display_boleto_number">
        <BoletoNumber />
      </IfFeature>

      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        <IfFeature allFeatures={features} wanted="action_boleto_copy_code">
          <CopyToClipboardButton />
        </IfFeature>

        <IfFeature allFeatures={features} wanted="action_boleto_save_pdf">
          <SaveToPdfButton />
        </IfFeature>
      </div>

      <Separator />

      <IfFeature allFeatures={features} wanted="display_boleto_tips">
        <BoletoTipsBox />
      </IfFeature>

    </div>
  );
}

const PaymentInfoWrapperStyle = {
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  padding: '15px',
  background: '#f8f8f9',
  borderRadius: '5px',
};

const BoletoTitleStyle = {
  fontSize: '22px',
  marginBottom: '16px',
};
